import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { heroImageProps, heroContentProps } from '../../helpers';
import HeroGridWrapper from '../HeroGridWrapper';
import HeroContent from '../HeroContent';
import HeroImage from '../HeroImage';

export const generateHeroClassNames = ({
  layout,
}) => classNames(
  'grid-x',
  'hero',
  'hero-full-block', // ! TODO This is to maintain backward compatibility and will be removed in the future
  'hero-full-block-quarter',
  {
    [`hero-full-block--${layout}`]: layout,
  },
);

export const generateHeroImageClassNames = ({ layout }) => classNames(
  'cell',
  'hero-full-block-quarter__image',
  {
    'xsmall-16 large-11': layout === 'horizontal',
  },
);

export const generateHeroContentClassNames = ({
  layout,
  theme,
}) => classNames(
  'cell',
  'hero-full-block-quarter__content',
  'align-middle',
  'flex-container',
  {
    'xsmall-16 large-5': layout === 'horizontal',
    'align-center': layout === 'vertical',
    [`hero-full-block-quarter__content--${theme}`]: theme,
  },
);

const HeroFullBlockQuarter = ({
  heroData,
  isUnderlined = true,
  isContentFirst = false,
  fullWidth = true,
  layout = 'horizontal',
  ctaType = 'link',
  headingLevel = 1,
  theme = 'primary',
  onClick,
  headingHasLink,
  imageHasLink,
  openLinkInNewTab = false,
}) => (
  <HeroGridWrapper
    fullWidth={fullWidth}
  >
    <div className={generateHeroClassNames({ layout })}>
      {isContentFirst ? (
        <Fragment>
          <HeroContent {...heroContentProps({
              heroData,
              isUnderlined,
              ctaType,
              headingLevel,
              heroContentClassName: generateHeroContentClassNames({ layout, theme }),
              heroContentBoxClassName: 'hero-full-block-quarter__content-box',
              labelExtraClass: 'hero-full-block-quarter__label',
              headingExtraClass: 'hero-full-block-quarter__heading',
              headingIntroExtraClass: 'hero-full-block-quarter__heading-introduction',
              descriptionExtraClass: 'hero-full-block-quarter__text',
              ctaExtraClass: 'hero-full-block-quarter',
              onClick,
              headingHasLink,
              openLinkInNewTab,
            })}
          />
          <HeroImage {...heroImageProps({
              heroData,
              imageHasLink,
              heroImageClassName: generateHeroImageClassNames({ layout }),
            })}
          />
        </Fragment>
      ) : (
        <Fragment>
          <HeroImage {...heroImageProps({
              heroData,
              imageHasLink,
              heroImageClassName: generateHeroImageClassNames({ layout }),
            })}
          />
          <HeroContent {...heroContentProps({
              heroData,
              isUnderlined,
              ctaType,
              headingLevel,
              heroContentClassName: generateHeroContentClassNames({ layout, theme }),
              heroContentBoxClassName: 'hero-full-block-quarter__content-box',
              labelExtraClass: 'hero-full-block-quarter__label',
              headingExtraClass: 'hero-full-block-quarter__heading',
              headingIntroExtraClass: 'hero-full-block-quarter__heading-introduction',
              descriptionExtraClass: 'hero-full-block-quarter__text',
              ctaExtraClass: 'hero-full-block-quarter',
              onClick,
              headingHasLink,
              openLinkInNewTab,
            })}
          />
        </Fragment>
      )}
    </div>
  </HeroGridWrapper>
);

HeroFullBlockQuarter.propTypes = {
  heroData: PropTypes.shape({
    description: PropTypes.string,
    heading: PropTypes.string,
    headingIntroduction: PropTypes.string,
    link: PropTypes.shape({
      linkText: PropTypes.string,
      linkUrl: PropTypes.string,
    }),
    imageSrc: PropTypes.string,
    imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    })),
    heroTag: PropTypes.string,
  }),
  isUnderlined: PropTypes.bool,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  isContentFirst: PropTypes.bool,
  fullWidth: PropTypes.bool,
  ctaType: PropTypes.oneOf(['link', 'button']),
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  theme: PropTypes.oneOf(['primary', 'secondary']),
  onClick: PropTypes.func,
  headingHasLink: PropTypes.bool,
  imageHasLink: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
};

export default HeroFullBlockQuarter;
